import { render, staticRenderFns } from "./SplitSelectorAntV.vue?vue&type=template&id=21819be8&scoped=true"
import script from "./SplitSelectorAntV.vue?vue&type=script&lang=js"
export * from "./SplitSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./SplitSelectorAntV.vue?vue&type=style&index=0&id=21819be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21819be8",
  null
  
)

export default component.exports